import React, { useState, useEffect } from 'react'
import { CButton, CModal, CModalHeader, CModalTitle, CModalBody } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilWarning } from '@coreui/icons'
import PropTypes from 'prop-types'
import api from '../api/api'

const Aviso = (props) => {
  const { seccion } = props
  const [avisos, setAvisos] = useState([])
  const [mostrar, setMostrar] = useState(false)
  const [loading, setLoading] = useState(true)

  const buscar = () => {
    api
      .aviso({ seccion: seccion })
      .then((response) => {
        if (response.data.code === 200 && response.data.data.length > 0) {
          setAvisos(response.data.data)
          setMostrar(true)
        } else {
          setAvisos([])
          setMostrar(false)
        }
      })
      .catch((error) => {
        setAvisos([])
        setMostrar(false)
      })
  }

  if (loading) {
    buscar()
    setLoading(false)
  }

  return (
    <div>
      {avisos.length > 0 && (
        <CButton
          color="warning"
          className="d-flex align-items-center"
          onClick={() => setMostrar(true)}
        >
          <CIcon icon={cilWarning} className="flex-shrink-0 me-2" width={24} height={24} />
          <div>Aviso</div>
        </CButton>
      )}
      <CModal size="xl" scrollable visible={mostrar} onClose={() => setMostrar(false)}>
        <CModalHeader>
          <CModalTitle>{new Object(avisos[0]).titulo}</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div dangerouslySetInnerHTML={{ __html: new Object(avisos[0]).mensaje }}></div>
        </CModalBody>
      </CModal>
    </div>
  )
}

Aviso.propTypes = {
  seccion: PropTypes.string,
}

export default Aviso
